<div class="post__comments flex flex-col gap-8">
  <app-new-comment-form
    (onNewCommentAdded)="addComment($event)"
  ></app-new-comment-form>
  <div class="comment__container flex flex-col gap-6">
    @for (comment of comments(); track comment._id) {
      <app-comment-details [comment]="comment"></app-comment-details>
    }
  </div>

  <div class="more__comments flex justify-center items-center gap-2">
    @if (!isNoMoreComments() && !isLoading()) {
      <p (click)="getComments()" translate>See 5 more comments</p>
      <div inlineSVG="landing/chevron-down.svg"></div>
    }
    @if (isLoading()) {
      <p translate>Loading...</p>
    }
  </div>
</div>
